const ThreeDotsLoading = () => {
  return (
    <span className="thinking_container" aria-label="Loading">
      {[0, 1, 2].map((index) => (
        <div 
          key={index} 
          className="thinking_dot" 
          style={{ animationDelay: `${index * 0.15}s` }} 
        />
      ))}
    </span>
  );
};

export default ThreeDotsLoading;